import { Component, computed, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { MatChipListbox, MatChipOption, MatChipRemove } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { SelectedCropField } from '@app/irrigations/models/models';
import { CropFieldDeselectEvent } from '@app/irrigations/models/ui-models';

@Component({
  selector: 'app-irrigation-dialog-crop-field-selection',
  imports: [
    MatChipListbox,
    MatChipOption,
    MatChipRemove,
    MatIcon,
  ],
  templateUrl: './irrigation-dialog-crop-field-selection.component.html',
})
export class IrrigationDialogCropFieldSelectionComponent {
  public readonly selectedCropFields: InputSignal<SelectedCropField[]> = input.required<SelectedCropField[]>();
  public readonly readOnly = input(false);
  public readonly cropFieldDeselected: OutputEmitterRef<CropFieldDeselectEvent> = output<CropFieldDeselectEvent>();

  protected readonly selectedCropFieldsCount: Signal<number> = computed(() => this.selectedCropFields().length);

  protected deselectCropField(selectedCropField: SelectedCropField) {
    if (this.readOnly()) {
      return;
    }

    this.cropFieldDeselected.emit({ id: selectedCropField.id });
  }
}
